module.exports = __webpack_public_path__ + "static/fitbit-settings-ios-v2-dea514f6bed3b5aa2919f007cc3be0a3.png";